import { Component, EventEmitter, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { DateValidators } from "src/validators/date-validators";

@Component({
    selector: "app-filter-list-quotes",
    templateUrl: "./filter-list-quotes.component.html",
    styleUrls: ["./filter-list-quotes.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FilterListQuotesComponent implements OnInit {
  public formFilterListQuotes: UntypedFormGroup = null;
  @Output() submitFilters = new EventEmitter<void>();

  constructor(private _fb: UntypedFormBuilder) {}

  ngOnInit(): void {
    this.initializeformFilterQuotes();
  }

  /**
   *
   * @returns
   */
  public onFilterListBillsQuotes(): UntypedFormGroup {
    if (this.formFilterListQuotes) {
      return this.formFilterListQuotes;
    }
  }

  /**
   * Handle the initialization of the list quotes filter form field
   */
  private initializeformFilterQuotes(): void {
    this.formFilterListQuotes = this._fb.group({
      quoteNumber: [""],
      quoteDate: [""],

      fromDate: [""],
      toDate: [""],
    });
  }
}
